import styled from 'styled-components';

interface CardProps {
  padding?: string;
  margin?: string;
  background?: string;
  borderRadius?: string;
  boxShadow?: string;
  border?: string;
  hover?: boolean;
  clickable?: boolean;
}

export const Card = styled.div<CardProps>`
  background: ${props => props.background || 'white'};
  padding: ${props => props.padding || '1.5rem'};
  margin: ${props => props.margin || '0'};
  border-radius: ${props => props.borderRadius || '12px'};
  box-shadow: ${props => props.boxShadow || '0 2px 8px rgba(0, 0, 0, 0.1)'};
  border: ${props => props.border || 'none'};
  cursor: ${props => props.clickable ? 'pointer' : 'default'};
  transition: ${props => props.hover || props.clickable ? 'all 0.2s ease' : 'none'};
  
  ${props => (props.hover || props.clickable) && `
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  `}
`;

// Specialized card variants
export const UserCard = styled(Card)`
  display: grid;
  grid-template-columns: minmax(100px, 1fr) minmax(100px, 1fr) minmax(180px, 2fr) minmax(130px, 1.5fr) minmax(130px, 1.5fr) minmax(100px, 1fr) minmax(180px, 2fr) minmax(130px, 1.5fr) minmax(80px, 1fr) minmax(100px, 1fr);
  gap: 0.5rem;
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
  cursor: pointer;
  transition: all 0.2s ease;
  align-items: center;
  border-radius: 0;
  box-shadow: none;

  &:hover {
    background: #f8f9fa;
    transform: none;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const CompanyCard = styled(Card)`
  cursor: pointer;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`;

export const VacancyCard = styled(Card)`
  border: 1px solid #e5e7eb;
  margin-bottom: 16px;
`;

export const ImportOptionCard = styled(Card)`
  background: white;
  border: 2px solid #e5e7eb;
  padding: 32px 24px;
  cursor: pointer;
  text-align: center;
  
  &:hover {
    border-color: #667eea;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
    transform: translateY(-2px);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const CurrentContactCard = styled(Card)`
  border: 1px solid #e5e7eb;
  margin-bottom: 16px;
`;

export const ScraperStatusCard = styled(Card)`
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  margin-bottom: 20px;
`;

export const LivePreviewContainer = styled(Card)`
  border: 1px solid #e5e7eb;
  overflow: hidden;
  margin-bottom: 16px;
  padding: 0;
`;